import { render, staticRenderFns } from "./ProdExpenseAmend.vue?vue&type=template&id=bcfda938&scoped=true"
import script from "./ProdExpenseAmend.vue?vue&type=script&lang=js"
export * from "./ProdExpenseAmend.vue?vue&type=script&lang=js"
import style0 from "./ProdExpenseAmend.vue?vue&type=style&index=0&id=bcfda938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfda938",
  null
  
)

export default component.exports